export const GET_AUTH = 'GET_AUTH';
export const GET_AUTH_SUCCESS = 'GET_AUTH_SUCCESS';
export const GET_AUTH_FAILED = 'GET_AUTH_FAILED';

export const TERMINATE_SESSION = 'TERMINATE_SESSION';
export const REMOVE_AUTH = 'REMOVE_AUTH';

export const REDIRECT_URL = 'REDIRECT_URL'

export const GET_PAYMENT_ID = 'GET_PAYMENT_ID'